import { getUploadUrl } from '@/utils/apiBase'

export const globalConfig = {
  uploadUrl: getUploadUrl()
}
